import React, { useRef } from "react";
import { Outlet } from "react-router-dom";
import Navbar from "../components/navbar";
import Footer from "../components/Footer";
import Router from "../routes";

const Layout = () => {
  const firstSectionRef = useRef();
  return (
    <div className="w-full overflow-x-hidden">
      <header>
        <Navbar transparent={true} />
      </header>
      <Outlet context={{ firstSectionRef }} />
      <Footer />
    </div>
  );
};

export default Layout;
